import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#12294d] dark:bg-[#040a16] text-white transition-colors duration-500" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-14">
        <div>
          <p className="font-extrabold tracking-tight text-2xl">
            <span>Med</span>
            <span className="text-[#2ab5cf]">Verify</span>
          </p>
          <p className="text-[0.65rem] tracking-[0.35em] uppercase text-slate-400 font-semibold mt-1">
            Services
          </p>
          <p className="mt-6 text-slate-300 text-sm leading-relaxed max-w-xs">
            Your trusted partner in maritime medical quality assurance. Centralized medical review,
            clinic quality audits and maritime medical compliance.
          </p>
        </div>

        <div>
          <p className="overline-label mb-6">Navigate</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" data-testid="footer-link-home" className="text-slate-300 hover:text-[#2ab5cf] transition-colors">Corporate Wellness</Link></li>
            <li>
              <span className="text-slate-200 font-semibold">Marine Care</span>
              <ul className="mt-2 ml-1 space-y-2 border-l border-white/10 pl-4">
                <li><Link to="/peme-review" data-testid="footer-link-peme" className="text-slate-300 hover:text-[#2ab5cf] transition-colors">PEME Medical Review</Link></li>
                <li><Link to="/clinic-audit" data-testid="footer-link-audit" className="text-slate-300 hover:text-[#2ab5cf] transition-colors">Clinic Quality Audit</Link></li>
              </ul>
            </li>
          </ul>
        </div>

        <div>
          <p className="overline-label mb-6">Contact</p>
          <ul className="space-y-4 text-sm text-slate-300">
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#2ab5cf] shrink-0" />
              <a href="mailto:info@medverifys.com" data-testid="footer-email-link" className="hover:text-[#2ab5cf] transition-colors">info@medverifys.com</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#2ab5cf] shrink-0" />
              <a href="tel:+919867171984" data-testid="footer-phone-link" className="hover:text-[#2ab5cf] transition-colors">+91 98671 71984</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} MedVerify Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
